<template>
  <div class="modal_wrap on">
    <!--'on 추가'-->
    <div class="modal_inner">
      <div class="modal">
        <div class="modal_head">
          <h1 class="h1">위치 정보 확인 불가</h1>
        </div>
        <div class="modal_con">
          <div class="modal_txt">
            <div class="center">
              위치정보 제한 시 어플을 이용함에 있어<br />
              원활한 서비스가 제공되지 못하는 점 양해 부탁드립니다.<br />
              <br />
              위치정보에 대한 동의는 디바이스 [권한]<br />
              설정에서 승인이 가능합니다.
            </div>
          </div>
        </div>
        <div class="modal_btn">
          <div class="btn_wrap">
            <button class="btn bo grey" v-on:click="$emit('close')">
              닫기
            </button>
            <button class="btn" v-on:click="$emit('setting')">
              설정하러 가기
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'GPSUseConfirmModal',
};
</script>

<style scoped></style>
